import { pickActiveEvmWallet, connectEvmWallet } from './detectEvmWallets';
import { EVM_WALLET_SIGN_MSG, evmWalletMismatchMsg } from './evmWalletMessages';
import { signHlUserTypedData, formatHlSignNetworkError } from './hlSignNetwork';

export async function payCommissionWithBrowserWallet({ walletAddress, preparePayload }) {
  const w = await pickActiveEvmWallet();
  if (!w) throw new Error(EVM_WALLET_SIGN_MSG);

  const { address } = await connectEvmWallet(w.provider);
  if (
    walletAddress &&
    address.toLowerCase() !== String(walletAddress).trim().toLowerCase()
  ) {
    throw new Error(evmWalletMismatchMsg(address));
  }

  let signature;
  try {
    signature = await signHlUserTypedData(w.provider, address, preparePayload.typedData);
  } catch (e) {
    throw new Error(formatHlSignNetworkError(e));
  }

  return {
    method: 'browser',
    action: preparePayload.action,
    nonce: preparePayload.nonce,
    signature,
  };
}
